import { useState } from "react";
import { ICON_CATEGORIES } from "../../constants/emoji";

export function IconPicker({ current, onSelect }) {
  const [cat, setCat] = useState("Animals");
  return (
    <div className="icon-picker">
      <div className="icon-cat-tabs">
        {Object.keys(ICON_CATEGORIES).map(c => (
          <button key={c} className={`icon-cat-btn ${cat === c ? "on" : ""}`} onClick={() => setCat(c)}>{c}</button>
        ))}
      </div>
      <div className="icon-grid">
        {ICON_CATEGORIES[cat].map(ic => (
          <div key={ic} className={`icon-opt ${current === ic ? "chosen" : ""}`} onClick={() => onSelect(ic)}>{ic}</div>
        ))}
      </div>
    </div>
  );
}
